import { render } from "./viewTrustDetailsTable.vue?vue&type=template&id=1b8b833b&scoped=true"
import script from "./viewTrustDetailsTable.vue?vue&type=script&lang=js"
export * from "./viewTrustDetailsTable.vue?vue&type=script&lang=js"

import "./viewTrustDetailsTable.vue?vue&type=style&index=0&id=1b8b833b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8b833b"]])

export default __exports__